import { DashboardService } from "./../../../dashboard.service";
import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";

import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs";
import { FilesManagerService } from "src/app/dashboard/files-manager/files-manager.service";
import { UploadProgressBarComponent } from "../../../../utils/upload-progress-bar/upload-progress-bar.component";
import { NgClass, NgFor, NgIf } from "@angular/common";
import { DragDropDirective } from "../../common/drag-drop.directive";

declare var jQuery: any;

/* This is a component which we pass in modal*/
@Component({
    selector: "app-modal-file-upload",
    templateUrl: "./file-upload-modal.component.html",
    styleUrls: [
        "../../../files-manager/files-manager.component.scss",
        "./file-upload-modal.component.scss",
    ],
    imports: [
        DragDropDirective,
        NgClass,
        NgFor,
        NgIf,
        UploadProgressBarComponent,
    ]
})
export class FileUploadModalComponent implements OnInit {
  public onClose: Subject<boolean>;
  public onUpload: Subject<any>;

  @Input() currentConversationID: number;
  @Input() targetFolder: string;
  @Input() staff: boolean;
  @Input() formdataOnly: boolean = false;
  @Input() type: string;
  @Input() recurrency: boolean = false;

  @ViewChild("fileUpload", { static: true }) fileUpload: ElementRef;

  selectedFiles = [];
  is_loading = false;

  files: any = [];

  has_file: boolean;
  has_recurrency: boolean;

  showProgressBar: boolean = false;
  progressPercentage: number = 0;

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: HotToastService,
    private filesManagerService: FilesManagerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
    this.onUpload = new Subject();
    this.has_recurrency = true;
  }

  handleRecurrencyRadioChange(event) {
    const radio = event.target.value;
    if (radio == "all_instances") {
      console.log(radio);
      this.has_recurrency = true;
    } else if (radio == "this_instance") {
      console.log(radio);
      this.has_recurrency = false;
    }
  }

  // ACTION

  fileChange(event) {
    if (event.length > 0) {
      this.has_file = true;

      for (let i = 0; i < event.length; i++) {
        this.files.push(event[i]);

        const file_: File = event[i];
        const currentIdx = this.selectedFiles.length;
        const fileObj = {
          filename: file_.name,
          ext: file_.name.split(".").pop(),
        };

        this.fileUpload.nativeElement.src = URL.createObjectURL(file_);

        console.log(fileObj);

        if (
          fileObj.ext === "jpg" ||
          fileObj.ext === "jpeg" ||
          fileObj.ext === "gif" ||
          fileObj.ext === "png"
        ) {
          const reader = new FileReader();
          reader.readAsDataURL(file_);

          reader.onload = function () {
            jQuery(".item" + currentIdx).css(
              "background",
              "url(" + reader.result + ")"
            );
          };
          reader.onerror = function (error) {
            console.log("Error: ", error);
          };
        } else {
          jQuery(".item" + currentIdx).attr("style", "");
        }

        this.selectedFiles.push(fileObj);
      }
    } else {
      this.has_file = false;
    }
  }

  removeFile(i: number) {
    this.files.splice(i, 1);
    this.selectedFiles.splice(i, 1);
    if (this.selectedFiles.length === 0) {
      this.has_file = false;
    }
  }

  // upload() {
  // this.is_loading = true;
  // const formData: FormData = new FormData();

  // this.files.forEach((file_: File) => {
  //   file_["recurrency"] = this.has_recurrency;
  //   formData.append("files", file_, file_.name);
  // });

  // formData.forEach((key, value) => console.log("entry", key, value));

  // if (!this.formdataOnly) {
  //   console.log("COMENÇANDO O TESTE");
  //   this.startProgress();
  // console.log("uploading to", this.targetFolder);

  // this.filesManagerService
  //   .uploadFiles(
  //     this.currentConversationID,
  //     this.targetFolder,
  //     this.staff,
  //     formData
  //   )
  //   .then(
  //     (result) => {
  //       this.onClose.next(false);
  //       this.bsModalRef.hide();
  //       this.toastr.success("File(s) uploaded successfully.", "Success!");
  //       this.is_loading = false;
  //     },
  //     (error) => {
  //       console.log(error);
  //       this.toastr.error(
  //         error.error.message
  //           ? error.error.message
  //           : "Something went wrong when uploading the file(s).",
  //         "Oops!"
  //       );
  //       this.is_loading = false;
  //     }
  //   );
  // }
  // else {
  //   this.is_loading = false;
  //   this.onUpload.next(this.files);
  //   this.bsModalRef.hide();
  // }
  // }

  // processFiles(files) {
  //   for (const file of files) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(file); // read file as data url
  //     reader.onload = (event: any) => {
  //       // called once readAsDataURL is completed
  //       this.uploadedMedia.push({
  //         FileName: file.name,
  //         FileSize:
  //           this.filesManagerService.getFileSize(file.size) +
  //           " " +
  //           this.filesManagerService.getFileSizeUnit(file.size),
  //         FileType: file.type,
  //         FileUrl: event.target.result,
  //         FileProgessSize: 0,
  //         FileProgress: 0,
  //         ngUnsubscribe: new Subject<any>(),
  //       });

  //       this.startProgress(file, this.uploadedMedia.length - 1);
  //     };
  //   }
  // }

  async startProgress() {
    if (!this.formdataOnly) {
      if(this.targetFolder === 'easy-upload') {
        this.files.forEach((file_: File, idx, array) => {
          let formData: FormData = new FormData();
          formData.append("from_easy_upload", "true");
          formData.append("files", file_, file_.name);
          // console.log("UPLOADING FILE: ", formData.getAll('files')[i]);
          // return;
          this.filesManagerService
          .uploadSingleFile(
            this.currentConversationID,
            formData,
          )
          .subscribe(
            (res: any) => {
              this.showProgressBar = true;
              if (res?.status === "progress") {
                let serverPercentage = res?.message;
                this.progressPercentage = serverPercentage;
                this.cdr.detectChanges();
                console.log("PROGRESS: ", this.progressPercentage);
                if (this.progressPercentage === 100) {
                  this.is_loading = true;
                  this.showProgressBar = false;
                  if (idx === 0){ 
                    this.toastr.info("Files are being processed.");
                  }
                  this.cdr.detectChanges();
                }
              } else if (res?.status === "completed") {
                this.cdr.detectChanges();
                this.showProgressBar = false;
                this.progressPercentage = 0;
                if (idx === array.length - 1){ 
                  this.toastr.success("File(s) uploaded successfully.");
                }
                this.onClose.next(false);
                this.bsModalRef.hide();
                this.is_loading = false;
              }
            },
            (error: any) => {
              console.log(error);
              this.toastr.error(
                error.error.message
                  ? error.error.message
                  : "Something went wrong when uploading the file(s)."
              );
              this.is_loading = false;
            }
          );
        });
      } else {
        let formData: FormData = new FormData();
        this.files.forEach((file_: File) => {
          file_["recurrency"] = this.has_recurrency;
          formData.append("files", file_, file_.name);
        });
        this.filesManagerService
          .newUploadFiles(
            this.currentConversationID,
            this.targetFolder,
            this.staff,
            formData
          )
          .subscribe(
            (res: any) => {
              this.showProgressBar = true;
              if (res?.status === "progress") {
                let serverPercentage = res?.message;
                this.progressPercentage = serverPercentage;
                this.cdr.detectChanges();
                console.log("PROGRESS: ", this.progressPercentage);
                if (this.progressPercentage === 100) {
                  this.is_loading = true;
                  this.showProgressBar = false;
                  this.toastr.info("Files are being processed.");
                  this.cdr.detectChanges();
                }
              } else if (res?.status === "completed") {
                this.cdr.detectChanges();
                this.showProgressBar = false;
                this.progressPercentage = 0;
                this.onClose.next(false);
                this.bsModalRef.hide();
                this.toastr.success("File(s) uploaded successfully.");
                this.is_loading = false;
              }
            },
            (error: any) => {
              console.log(error);
              this.toastr.error(
                error.error.message
                  ? error.error.message
                  : "Something went wrong when uploading the file(s)."
              );
              this.is_loading = false;
            }
          );
      }
    } else {
      this.is_loading = false;
      this.onUpload.next(this.files);
      this.bsModalRef.hide();
    }
  }
}
